export const NOTIFICATIONS_STORE_NAME = 'notifications';

export interface Notification {
  type: NotificationType;
  time: Date;
  data: any;
  url?: string;
}

export enum NotificationType {
  FILE,
  ALCOHOL_LOCK_NEGATIVE_RESULT,
  PANIC_BUTTON,
  VEHICLE_OFF_COURSE,
  SNAPSHOT_FILE,
  ALCOHOL_TEST_REQUEST_DELIVERED
}
